import api from '../../api';

const BASE_URL = '/cementing-design/project';

// PROJECT CRUD
// =================================================

export const fetchProjectList = async (owner) => {
  const response = await api.get(`${BASE_URL}?owner=${owner}`);
  return response.data;
};

export const readProject = async (projectId) => {
  const response = await api.get(`${BASE_URL}/${projectId}`);
  return response.data;
};

export const updateProject = async (projectId, project) => {
  const response = await api.put(`${BASE_URL}/${projectId}`, project);
  return response.data;
};

export const addProject = async (project) => {
  const response = await api.post(`${BASE_URL}`, project);
  return response.data;
};

export const duplicateProject = async (project) => {
  const response = await api.post(`${BASE_URL}`, project);
  return response.data;
};

export const removeProject = async (projectId) => {
  const response = await api.delete(`${BASE_URL}/${projectId}`);
  return response.data;
};

export const permanentDeleteProjects = async () => {
  const response = await api.delete(`${BASE_URL}`);
  return response.data;
};

export const createDemoProject = async (payload) => {
  const response = await api.post(`${BASE_URL}/demo`, payload);
  return response.data;
};

// PROJECT CONTROLLER
// =================================================

export const updateCementingDesign = async (projectId) => {
  const response = await api.post(`${BASE_URL}/${projectId}/run-program`);
  return response.data;
};

export const deleteCementingDesign = async (projectId) => {
  const response = await api.delete(`${BASE_URL}/${projectId}/delete-outputs`);
  return response.data;
};

// PROJECT INPUT AND OUTPUT
// =================================================

export const readInputGeneral = async (projectId) => {
  const response = await api.get(`${BASE_URL}/${projectId}/input-general`);
  return response.data;
};

export const updateInputGeneral = async (projectId, obj) => {
  const response = await api.put(`${BASE_URL}/${projectId}/input-general`, obj);
  return response.data;
};

export const readInputPressure = async (projectId) => {
  const response = await api.get(`${BASE_URL}/${projectId}/input-pressure`);
  return response.data;
};

export const updateInputPressure = async (projectId, obj) => {
  const response = await api.put(`${BASE_URL}/${projectId}/input-pressure`, obj);
  return response.data;
};

export const readInputCementProgram = async (projectId) => {
  const response = await api.get(`${BASE_URL}/${projectId}/input-cement-program`);
  return response.data;
};

export const updateInputCementProgram = async (projectId, obj) => {
  const response = await api.put(`${BASE_URL}/${projectId}/input-cement-program`, obj);
  return response.data;
};

export const readOutputKeyInfo = async (projectId) => {
  const response = await api.get(`${BASE_URL}/${projectId}/output-key-info`);
  return response.data;
};

export const updateOutputKeyInfo = async (projectId, obj) => {
  const response = await api.put(`${BASE_URL}/${projectId}/output-key-info`, obj);
  return response.data;
};

export const readOutputSummary = async (projectId) => {
  const response = await api.get(`${BASE_URL}/${projectId}/output-summary`);
  return response.data;
};

export const updateOutputSummary = async (projectId, obj) => {
  const response = await api.put(`${BASE_URL}/${projectId}/output-summary`, obj);
  return response.data;
};

export const readOutputPump = async (projectId) => {
  const response = await api.get(`${BASE_URL}/${projectId}/output-pump`);
  return response.data;
};

export const updateOutputPump = async (projectId, obj) => {
  const response = await api.put(`${BASE_URL}/${projectId}/output-pump`, obj);
  return response.data;
};
